export const useProductStore = defineStore(
  'ltc_product_id',
  () => {
    const licensedTerritory = useLicensedTerritory()

    const productIdMap = ref<Record<string, string>>({})

    const deleteProductId = (productName: string) => {
      /* eslint-disable @typescript-eslint/no-dynamic-delete */
      delete productIdMap.value[
        `${productName.toLocaleLowerCase()}_${licensedTerritory}`
      ]
    }

    const setProductId = (id: string, productName: string) => {
      productIdMap.value[
        `${productName.toLocaleLowerCase()}_${licensedTerritory}`
      ] = id.toLocaleLowerCase()
    }

    const getProductId = (productName: string) =>
      productIdMap.value[
        `${productName.toLocaleLowerCase()}_${licensedTerritory}`
      ] || null

    return {
      deleteProductId,
      getProductId,
      productIdMap,
      setProductId,
    }
  },
  {
    persist: {
      storage: piniaPluginPersistedstate.localStorage(),
    },
  },
)
